/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerLiveMigrationDetail } from '../models';
// @ts-ignore
import type { ContainerLiveMigrationFilter } from '../models';
// @ts-ignore
import type { ContainerLiveMigrationSummary } from '../models';
// @ts-ignore
import type { ListContainerLiveMigrationEventsResponse } from '../models';
// @ts-ignore
import type { ListContainerLiveMigrationFilterValuesResponse } from '../models';
// @ts-ignore
import type { ListContainerLiveMigrationIncompatibleWorkloadsResponse } from '../models';
// @ts-ignore
import type { ListContainerLiveMigrationWorkloadsResponse } from '../models';
// @ts-ignore
import type { ListContainerLiveMigrationsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ContainerLiveMigrationAPIApi - axios parameter creator
 * @export
 */
export const ContainerLiveMigrationAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns detailed information about a single container live migration including its state transition timeline.
         * @summary Returns container live migration detail with state transition timeline.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} migrationId Migration ID (UID of the Migration CR).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIGetContainerLiveMigrationDetail: async (organizationId: string, clusterId: string, migrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIGetContainerLiveMigrationDetail', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIGetContainerLiveMigrationDetail', 'clusterId', clusterId)
            // verify required parameter 'migrationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIGetContainerLiveMigrationDetail', 'migrationId', migrationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migrations/{migrationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns aggregated container live migration summary with time-series breakdown for a cluster.
         * @summary Returns container live migration summary with time-series breakdown.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum} [step] Granularity of timeline data points.
         * @param {string} [timeZone] Optional time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIGetContainerLiveMigrationSummary: async (organizationId: string, clusterId: string, startTime?: string, endTime?: string, step?: ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum, timeZone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIGetContainerLiveMigrationSummary', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIGetContainerLiveMigrationSummary', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migrations-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of container live migrations events.
         * @summary Returns a paginated list of container live migrations for a given workload.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationFilter} containerLiveMigrationFilter 
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationEvents: async (organizationId: string, clusterId: string, containerLiveMigrationFilter: ContainerLiveMigrationFilter, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationEvents', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationEvents', 'clusterId', clusterId)
            // verify required parameter 'containerLiveMigrationFilter' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationEvents', 'containerLiveMigrationFilter', containerLiveMigrationFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migration-events`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(containerLiveMigrationFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns distinct filter values for the container live migration list endpoints.
         * @summary Returns distinct filter values for container live migration filters.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationFilter} containerLiveMigrationFilter 
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum} [field] Filter field to retrieve values for.
         * @param {string} [keyword] Optional keyword for typeahead search matched against the filter value.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationFilterValues: async (organizationId: string, clusterId: string, containerLiveMigrationFilter: ContainerLiveMigrationFilter, field?: ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum, keyword?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationFilterValues', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationFilterValues', 'clusterId', clusterId)
            // verify required parameter 'containerLiveMigrationFilter' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationFilterValues', 'containerLiveMigrationFilter', containerLiveMigrationFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migration-filter-values`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(containerLiveMigrationFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of workloads that are not compatible with container live migration.  Based on the latest cluster snapshot, not affected by time range parameters.
         * @summary Returns a paginated list of workloads incompatible with container live migration.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migration-incompatible-workloads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of container live migration workloads with aggregate counts.
         * @summary Returns a list of workloads with container live migration counts.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationFilter} containerLiveMigrationFilter 
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationWorkloads: async (organizationId: string, clusterId: string, containerLiveMigrationFilter: ContainerLiveMigrationFilter, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationWorkloads', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationWorkloads', 'clusterId', clusterId)
            // verify required parameter 'containerLiveMigrationFilter' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrationWorkloads', 'containerLiveMigrationFilter', containerLiveMigrationFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migration-workloads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(containerLiveMigrationFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of container live migrations with their latest state.
         * @summary Returns a paginated list of container live migrations.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum} [status] Optional status filter.
         * @param {string} [search] Optional search term matched against migration_id, pod_name, namespace.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrations: async (organizationId: string, clusterId: string, status?: ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum, search?: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrations', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('containerLiveMigrationAPIListContainerLiveMigrations', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/container-live-migrations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerLiveMigrationAPIApi - functional programming interface
 * @export
 */
export const ContainerLiveMigrationAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerLiveMigrationAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns detailed information about a single container live migration including its state transition timeline.
         * @summary Returns container live migration detail with state transition timeline.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} migrationId Migration ID (UID of the Migration CR).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIGetContainerLiveMigrationDetail(organizationId: string, clusterId: string, migrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerLiveMigrationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIGetContainerLiveMigrationDetail(organizationId, clusterId, migrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIGetContainerLiveMigrationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns aggregated container live migration summary with time-series breakdown for a cluster.
         * @summary Returns container live migration summary with time-series breakdown.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum} [step] Granularity of timeline data points.
         * @param {string} [timeZone] Optional time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIGetContainerLiveMigrationSummary(organizationId: string, clusterId: string, startTime?: string, endTime?: string, step?: ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum, timeZone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerLiveMigrationSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIGetContainerLiveMigrationSummary(organizationId, clusterId, startTime, endTime, step, timeZone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIGetContainerLiveMigrationSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of container live migrations events.
         * @summary Returns a paginated list of container live migrations for a given workload.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationFilter} containerLiveMigrationFilter 
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIListContainerLiveMigrationEvents(organizationId: string, clusterId: string, containerLiveMigrationFilter: ContainerLiveMigrationFilter, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContainerLiveMigrationEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIListContainerLiveMigrationEvents(organizationId, clusterId, containerLiveMigrationFilter, pageLimit, pageCursor, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIListContainerLiveMigrationEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns distinct filter values for the container live migration list endpoints.
         * @summary Returns distinct filter values for container live migration filters.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationFilter} containerLiveMigrationFilter 
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum} [field] Filter field to retrieve values for.
         * @param {string} [keyword] Optional keyword for typeahead search matched against the filter value.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIListContainerLiveMigrationFilterValues(organizationId: string, clusterId: string, containerLiveMigrationFilter: ContainerLiveMigrationFilter, field?: ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum, keyword?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContainerLiveMigrationFilterValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIListContainerLiveMigrationFilterValues(organizationId, clusterId, containerLiveMigrationFilter, field, keyword, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIListContainerLiveMigrationFilterValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of workloads that are not compatible with container live migration.  Based on the latest cluster snapshot, not affected by time range parameters.
         * @summary Returns a paginated list of workloads incompatible with container live migration.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContainerLiveMigrationIncompatibleWorkloadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads(organizationId, clusterId, pageLimit, pageCursor, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of container live migration workloads with aggregate counts.
         * @summary Returns a list of workloads with container live migration counts.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationFilter} containerLiveMigrationFilter 
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIListContainerLiveMigrationWorkloads(organizationId: string, clusterId: string, containerLiveMigrationFilter: ContainerLiveMigrationFilter, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContainerLiveMigrationWorkloadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIListContainerLiveMigrationWorkloads(organizationId, clusterId, containerLiveMigrationFilter, pageLimit, pageCursor, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIListContainerLiveMigrationWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of container live migrations with their latest state.
         * @summary Returns a paginated list of container live migrations.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum} [status] Optional status filter.
         * @param {string} [search] Optional search term matched against migration_id, pod_name, namespace.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerLiveMigrationAPIListContainerLiveMigrations(organizationId: string, clusterId: string, status?: ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum, search?: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContainerLiveMigrationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerLiveMigrationAPIListContainerLiveMigrations(organizationId, clusterId, status, search, pageLimit, pageCursor, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerLiveMigrationAPIApi.containerLiveMigrationAPIListContainerLiveMigrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerLiveMigrationAPIApi - factory interface
 * @export
 */
export const ContainerLiveMigrationAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerLiveMigrationAPIApiFp(configuration)
    return {
        /**
         * Returns detailed information about a single container live migration including its state transition timeline.
         * @summary Returns container live migration detail with state transition timeline.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIGetContainerLiveMigrationDetail(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContainerLiveMigrationDetail> {
            return localVarFp.containerLiveMigrationAPIGetContainerLiveMigrationDetail(requestParameters.organizationId, requestParameters.clusterId, requestParameters.migrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns aggregated container live migration summary with time-series breakdown for a cluster.
         * @summary Returns container live migration summary with time-series breakdown.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIGetContainerLiveMigrationSummary(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContainerLiveMigrationSummary> {
            return localVarFp.containerLiveMigrationAPIGetContainerLiveMigrationSummary(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of container live migrations events.
         * @summary Returns a paginated list of container live migrations for a given workload.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationEvents(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContainerLiveMigrationEventsResponse> {
            return localVarFp.containerLiveMigrationAPIListContainerLiveMigrationEvents(requestParameters.organizationId, requestParameters.clusterId, requestParameters.containerLiveMigrationFilter, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns distinct filter values for the container live migration list endpoints.
         * @summary Returns distinct filter values for container live migration filters.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationFilterValues(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContainerLiveMigrationFilterValuesResponse> {
            return localVarFp.containerLiveMigrationAPIListContainerLiveMigrationFilterValues(requestParameters.organizationId, requestParameters.clusterId, requestParameters.containerLiveMigrationFilter, requestParameters.field, requestParameters.keyword, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of workloads that are not compatible with container live migration.  Based on the latest cluster snapshot, not affected by time range parameters.
         * @summary Returns a paginated list of workloads incompatible with container live migration.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContainerLiveMigrationIncompatibleWorkloadsResponse> {
            return localVarFp.containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of container live migration workloads with aggregate counts.
         * @summary Returns a list of workloads with container live migration counts.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrationWorkloads(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContainerLiveMigrationWorkloadsResponse> {
            return localVarFp.containerLiveMigrationAPIListContainerLiveMigrationWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.containerLiveMigrationFilter, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of container live migrations with their latest state.
         * @summary Returns a paginated list of container live migrations.
         * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerLiveMigrationAPIListContainerLiveMigrations(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContainerLiveMigrationsResponse> {
            return localVarFp.containerLiveMigrationAPIListContainerLiveMigrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.status, requestParameters.search, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for containerLiveMigrationAPIGetContainerLiveMigrationDetail operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetailRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetailRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetail
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetail
     */
    readonly clusterId: string

    /**
     * Migration ID (UID of the Migration CR).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetail
     */
    readonly migrationId: string
}

/**
 * Request parameters for containerLiveMigrationAPIGetContainerLiveMigrationSummary operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummaryRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummaryRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummary
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummary
     */
    readonly clusterId: string

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummary
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummary
     */
    readonly endTime?: string

    /**
     * Granularity of timeline data points.
     * @type {'STEP_UNSPECIFIED' | 'ONE_DAY'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummary
     */
    readonly step?: ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum

    /**
     * Optional time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummary
     */
    readonly timeZone?: string
}

/**
 * Request parameters for containerLiveMigrationAPIListContainerLiveMigrationEvents operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEventsRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEventsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly clusterId: string

    /**
     * 
     * @type {ContainerLiveMigrationFilter}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly containerLiveMigrationFilter: ContainerLiveMigrationFilter

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEvents
     */
    readonly sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum
}

/**
 * Request parameters for containerLiveMigrationAPIListContainerLiveMigrationFilterValues operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly clusterId: string

    /**
     * 
     * @type {ContainerLiveMigrationFilter}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly containerLiveMigrationFilter: ContainerLiveMigrationFilter

    /**
     * Filter field to retrieve values for.
     * @type {'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_UNSPECIFIED' | 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_WORKLOAD_KIND' | 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_STATUS' | 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_WORKLOAD_NAME' | 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_NAMESPACE'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly field?: ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum

    /**
     * Optional keyword for typeahead search matched against the filter value.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly keyword?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValues
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads
     */
    readonly sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum
}

/**
 * Request parameters for containerLiveMigrationAPIListContainerLiveMigrationWorkloads operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly clusterId: string

    /**
     * 
     * @type {ContainerLiveMigrationFilter}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly containerLiveMigrationFilter: ContainerLiveMigrationFilter

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloads
     */
    readonly sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum
}

/**
 * Request parameters for containerLiveMigrationAPIListContainerLiveMigrations operation in ContainerLiveMigrationAPIApi.
 * @export
 * @interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationsRequest
 */
export interface ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly clusterId: string

    /**
     * Optional status filter.
     * @type {'CONTAINER_LIVE_MIGRATION_STATUS_UNSPECIFIED' | 'CONTAINER_LIVE_MIGRATION_STATUS_PENDING' | 'CONTAINER_LIVE_MIGRATION_STATUS_RUNNING' | 'CONTAINER_LIVE_MIGRATION_STATUS_READY' | 'CONTAINER_LIVE_MIGRATION_STATUS_POD_CREATED' | 'CONTAINER_LIVE_MIGRATION_STATUS_FAILED' | 'CONTAINER_LIVE_MIGRATION_STATUS_COMPLETED'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly status?: ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum

    /**
     * Optional search term matched against migration_id, pod_name, namespace.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly search?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrations
     */
    readonly sortOrder?: ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum
}

/**
 * ContainerLiveMigrationAPIApi - object-oriented interface
 * @export
 * @class ContainerLiveMigrationAPIApi
 * @extends {BaseAPI}
 */
export class ContainerLiveMigrationAPIApi extends BaseAPI {
    /**
     * Returns detailed information about a single container live migration including its state transition timeline.
     * @summary Returns container live migration detail with state transition timeline.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIGetContainerLiveMigrationDetail(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationDetailRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIGetContainerLiveMigrationDetail(requestParameters.organizationId, requestParameters.clusterId, requestParameters.migrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns aggregated container live migration summary with time-series breakdown for a cluster.
     * @summary Returns container live migration summary with time-series breakdown.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIGetContainerLiveMigrationSummary(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIGetContainerLiveMigrationSummaryRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIGetContainerLiveMigrationSummary(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.step, requestParameters.timeZone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of container live migrations events.
     * @summary Returns a paginated list of container live migrations for a given workload.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIListContainerLiveMigrationEvents(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationEventsRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIListContainerLiveMigrationEvents(requestParameters.organizationId, requestParameters.clusterId, requestParameters.containerLiveMigrationFilter, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns distinct filter values for the container live migration list endpoints.
     * @summary Returns distinct filter values for container live migration filters.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIListContainerLiveMigrationFilterValues(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIListContainerLiveMigrationFilterValues(requestParameters.organizationId, requestParameters.clusterId, requestParameters.containerLiveMigrationFilter, requestParameters.field, requestParameters.keyword, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of workloads that are not compatible with container live migration.  Based on the latest cluster snapshot, not affected by time range parameters.
     * @summary Returns a paginated list of workloads incompatible with container live migration.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of container live migration workloads with aggregate counts.
     * @summary Returns a list of workloads with container live migration counts.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIListContainerLiveMigrationWorkloads(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIListContainerLiveMigrationWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.containerLiveMigrationFilter, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of container live migrations with their latest state.
     * @summary Returns a paginated list of container live migrations.
     * @param {ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContainerLiveMigrationAPIApi
     */
    public containerLiveMigrationAPIListContainerLiveMigrations(requestParameters: ContainerLiveMigrationAPIApiContainerLiveMigrationAPIListContainerLiveMigrationsRequest, options?: RawAxiosRequestConfig) {
        return ContainerLiveMigrationAPIApiFp(this.configuration).containerLiveMigrationAPIListContainerLiveMigrations(requestParameters.organizationId, requestParameters.clusterId, requestParameters.status, requestParameters.search, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum = {
    STEP_UNSPECIFIED: 'STEP_UNSPECIFIED',
    ONE_DAY: 'ONE_DAY'
} as const;
export type ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum = typeof ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum[keyof typeof ContainerLiveMigrationAPIGetContainerLiveMigrationSummaryStepEnum];
/**
 * @export
 */
export const ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum = typeof ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum[keyof typeof ContainerLiveMigrationAPIListContainerLiveMigrationEventsSortOrderEnum];
/**
 * @export
 */
export const ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum = {
    UNSPECIFIED: 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_UNSPECIFIED',
    WORKLOAD_KIND: 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_WORKLOAD_KIND',
    STATUS: 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_STATUS',
    WORKLOAD_NAME: 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_WORKLOAD_NAME',
    NAMESPACE: 'CONTAINER_LIVE_MIGRATION_FILTER_FIELD_NAMESPACE'
} as const;
export type ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum = typeof ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum[keyof typeof ContainerLiveMigrationAPIListContainerLiveMigrationFilterValuesFieldEnum];
/**
 * @export
 */
export const ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum = typeof ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum[keyof typeof ContainerLiveMigrationAPIListContainerLiveMigrationIncompatibleWorkloadsSortOrderEnum];
/**
 * @export
 */
export const ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum = typeof ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum[keyof typeof ContainerLiveMigrationAPIListContainerLiveMigrationWorkloadsSortOrderEnum];
/**
 * @export
 */
export const ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum = {
    UNSPECIFIED: 'CONTAINER_LIVE_MIGRATION_STATUS_UNSPECIFIED',
    PENDING: 'CONTAINER_LIVE_MIGRATION_STATUS_PENDING',
    RUNNING: 'CONTAINER_LIVE_MIGRATION_STATUS_RUNNING',
    READY: 'CONTAINER_LIVE_MIGRATION_STATUS_READY',
    POD_CREATED: 'CONTAINER_LIVE_MIGRATION_STATUS_POD_CREATED',
    FAILED: 'CONTAINER_LIVE_MIGRATION_STATUS_FAILED',
    COMPLETED: 'CONTAINER_LIVE_MIGRATION_STATUS_COMPLETED'
} as const;
export type ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum = typeof ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum[keyof typeof ContainerLiveMigrationAPIListContainerLiveMigrationsStatusEnum];
/**
 * @export
 */
export const ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum = typeof ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum[keyof typeof ContainerLiveMigrationAPIListContainerLiveMigrationsSortOrderEnum];
